"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const helpers_1 = require("../../utils/helpers");
const Buttons_1 = require("../../Buttons");
const helpers_2 = require("../SearchableTable/helpers");
const SearchableTable_1 = __importDefault(require("../SearchableTable/SearchableTable"));
require("./index.css");
const initialSorting = {
    sortBy: null,
    direction: 0,
};
const PaginatedSearchableTable = (props) => {
    const { searchableTableProps, pageSize } = props;
    const { data, labelKeyMap, defaultSort } = searchableTableProps;
    const [page, setPage] = React.useState(1);
    const [query, setQuery] = React.useState("");
    const [sorting, setSorting] = React.useState(defaultSort ? defaultSort : initialSorting);
    const [filteredData, setFilteredData] = React.useState(data);
    const prevData = (0, helpers_1.usePrevious)(data);
    React.useEffect(() => {
        if (!prevData || (prevData && !(0, helpers_1.deepEquals)(prevData, data))) {
            setFilteredData((0, helpers_2.getFilteredData)(query, data, labelKeyMap));
            setPage(1);
        }
    }, [data]);
    const handleSearch = (searchQuery) => {
        setQuery(searchQuery);
        setFilteredData((0, helpers_2.getFilteredData)(searchQuery, data, labelKeyMap));
        setPage(1);
    };
    const handleSort = (columnKey) => {
        const activeDirection = columnKey === sorting.sortBy ? sorting.direction : 0;
        let newDirection;
        if (activeDirection === 1) {
            newDirection = -1;
        }
        else if (activeDirection === -1) {
            newDirection = 0;
        }
        else {
            newDirection = 1;
        }
        setSorting({ sortBy: columnKey, direction: newDirection });
        setPage(1);
    };
    const renderPaginationControls = () => {
        const totalPages = Math.ceil(Math.max(filteredData.length, 1) / pageSize);
        const isLastPage = page == totalPages;
        const isFirstPage = page === 1;
        if (isLastPage && isFirstPage) {
            return null;
        }
        return (React.createElement(Buttons_1.PaginationController, { page: page, totalPages: totalPages, onNext: () => setPage(page + 1), onPrev: () => setPage(page - 1) }));
    };
    let pageData = filteredData;
    if (sorting.sortBy) {
        pageData = (0, helpers_2.getSortedData)(sorting.sortBy, pageData, sorting.direction);
    }
    pageData = pageData.slice(pageSize * (page - 1), pageSize * page);
    const tableProps = Object.assign(Object.assign({}, searchableTableProps), { data: pageData, labelKeyMap, searchProps: { value: query, onChange: handleSearch }, sortProps: { sorting: sorting, onSort: handleSort }, searchDetail: renderPaginationControls() });
    return (React.createElement(React.Fragment, null,
        React.createElement(SearchableTable_1.default, Object.assign({}, tableProps)),
        React.createElement("div", { className: "paginated_searchable_table-bottom" }, renderPaginationControls())));
};
exports.default = PaginatedSearchableTable;
//# sourceMappingURL=PaginatedSearchableTable.js.map